import {clone, EmptyFunc} from "../utils/DBUtils";

class Reduction {
    reduction = EmptyFunc;
    type = "";
    builder = null;

    constructor(type, builder) {
        this.type = type;
        this.builder = builder;
    }

    reduce(reduction) {
        this.reduction = reduction;
        return this.builder;
    }
}

class ReducerBuilder {
    initialState = {};
    cases = {};

    constructor(initialState) {
        if (initialState !== undefined) {
            this.initialState = initialState;
        }
    }

    forType(type) {
        let reduction = new Reduction(type, this);
        this.cases[type] = reduction;
        return reduction;
    }

    build() {
        return (state, action) => {
            if (state === undefined) {
                // console.log(`initializing state from action ${action.type}`, this.initialState);
                return this.initialState;
            }

            if (this.cases[action.type]) {
                let newState = clone(state);
                try {
                    this.cases[action.type].reduction(newState, action);
                } catch (err) {
                    console.error("Failed to reduce action", action, err);
                    return state;
                }
                newState.lastAction = action.type;
                return newState;
            }

            return state;
        }
    }

    static make(initialState) {
        return new ReducerBuilder(initialState);
    }
}

export default ReducerBuilder;


// WEBPACK FOOTER //
// ./public/classes/ReducerBuilder.js